import { useAccount } from "@/context/account";
import { useCustomerAccountIdsStore } from "@/store/useCustomerAccountIdsStore";
import { getCustomerRouteId, type CustomerRouteIds } from "./customerRouteId";

/**
 * Builds `/:accountId/customers/:customerId...` paths. Call `rememberCustomer`
 * before navigating so the customer route can map the IAM id back to the CDH id.
 */
export function useCustomerPath() {
  const { accountRouteId } = useAccount();
  const iamIdByCdhId = useCustomerAccountIdsStore(
    (state) => state.iamIdByCdhId
  );
  const addCustomerAccountIds = useCustomerAccountIdsStore(
    (state) => state.addCustomerAccountIds
  );

  const getCustomerPath = (customer: CustomerRouteIds, subpath = "") =>
    `/${accountRouteId}/customers/${getCustomerRouteId(customer, iamIdByCdhId)}${subpath}`;

  const rememberCustomer = (customer: CustomerRouteIds) => {
    if (customer.iamId) {
      addCustomerAccountIds([{ cdhId: customer.id, iamId: customer.iamId }]);
    }
  };

  return { getCustomerPath, rememberCustomer };
}
